function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.189 5.224L9.754 1.66A.84.84 0 008.565.471L5 4.036 1.435.47A.84.84 0 00.246 1.659l3.565 3.565L.246 8.79a.84.84 0 001.189 1.188L5 6.413l3.565 3.565A.84.84 0 009.754 8.79L6.189 5.224z"
});

function SvgCancelIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 11
  }, props), _ref);
}

export default SvgCancelIcon;